import { isMobile } from './functions.js';

//
// Menu Toggle
//
function menu_toggle() {
	const menu_toggle = document.querySelectorAll(".menu-toggle");
	const html = document.querySelectorAll("html");
	const body = document.querySelectorAll("body");
	const mobileMenu = document.getElementById('primary-menu');
	const allElementsExceptMenu = document.querySelectorAll('a:not(.site-header a)');

	menu_toggle.forEach(menuItem => {
		menuItem.addEventListener('click', (e) => {
			e.preventDefault();

			var value = menuItem.getAttribute('aria-expanded');
			var aria = value === 'true' ? 'false' : 'true';
			menuItem.setAttribute('aria-expanded', aria);

			var tabIndex = mobileMenu.getAttribute('tabindex');
			var ariaTab = tabIndex === '1' ? '0' : '1';
			mobileMenu.setAttribute('tabindex', ariaTab);

			body[0].classList.toggle("toggled");
			menuItem.classList.toggle("toggled");
			html[0].classList.toggle("lock-scroll");

			menuItem.blur();

			// Set tab indices for all elements except the menu based on menu state
			allElementsExceptMenu.forEach(element => {
				element.tabIndex = aria === 'true' ? '-1' : '0';
			});


			// focus the first item in the menu when opening.
			if (aria === 'true') {
				setTimeout(() => {
					const firstFocusableElement = mobileMenu.querySelector('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
					if (firstFocusableElement) {
						firstFocusableElement.focus();
					}
				}, 100);
			}

		});
	});
}
// window.addEventListener('DOMContentLoaded', menu_toggle);
menu_toggle();

// // Remove active class from dropdown to prevent bugs if still hovering the menu.
// function removeDropdownActiveClass() {
// 	// Remove active class from dropdown to prevent bugs if still hovering the menu.
// 	nav_children.forEach((nav_child, i) => {
// 		nav_child.parentElement.classList.remove('active');
// 		nav_child.classList.remove('active');
// 	});
// }

//
// site-header on scroll
//
var lastScrollTop = 0;
var initialLoad = true;
function header_check() {

	const header = document.querySelector(".site-header");
	const hero = document.querySelector("[class*='hero']");

	header.style.transition = '0ms top';

	var scroll = window.pageYOffset,
		  content = hero.clientHeight,
		  position = hero.clientHeight / 2,
		  scrollTop = scroll;

	if( scrollTop >= content ) {
		// setTimeout(function() {
			header.classList.add("active");
			// header.style.transition = '300ms top';
		// }, 300);
	} else {
		header.classList.remove("active");
		// header.style.transition = '0ms top';
	}

	if (!initialLoad) {
		if (scrollTop > lastScrollTop) {

			// Scrolling down
			header.classList.add("down");
			header.classList.remove("up");
			console.log('down');
			header.style.transition = '300ms all';

			// prevent the transition from buggin out when changing to position fixed + scrolling down
			if( scrollTop >= position && scrollTop <= content ) {
				header.style.transition = 'none';
			}

		} else if(scrollTop < lastScrollTop) {

			// Scrolling up
			header.classList.remove("down");
			header.classList.add("up");
			console.log('up');
			header.style.transition = '300ms all';

			if( scrollTop >= position ) {
				header.style.transition = '300ms all';
			} else {
				header.style.transition = 'none';
			}


		} else {
			// nothing
		}
	}

	if( scrollTop >= position ) {
		header.classList.add("fixed");
		// header.style.transition = 'none';
	} else {
		header.classList.remove("fixed");
	}

	lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
	initialLoad = false;
}
window.addEventListener('load', header_check);
document.addEventListener('scroll', header_check);

// nav_children = document.querySelectorAll('.menu-item-has-children');
// nav_children.forEach((nav_child, i) => {
// 	nav_child.addEventListener('mouseover', (e) => {
// 		// console.log(e);
// 		nav_child.parentElement.classList.add('active');
// 		nav_child.classList.add('active');
// 	});
// 	nav_child.addEventListener('mouseout', (e) => {
// 		nav_child.parentElement.classList.remove('active');
// 		nav_child.classList.remove('active');
// 	});
// });


// Smooth scroll
// Handle anchor links
var anchorLinks = document.querySelectorAll('a[href*="#"]');
for (var i = 0; i < anchorLinks.length; i++) {
	var link = anchorLinks[i];
	if (link.getAttribute('href') !== '#' && link.getAttribute('href') !== '#0') {
		link.addEventListener('click', function(event) {
			// On-page links
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
				location.hostname == this.hostname
			) {
			// Figure out element to scroll to
			var target = document.querySelector(this.hash);
			target = target ? target : document.querySelector('[name=' + this.hash.slice(1) + ']');
			// Does a scroll target exist?
			if (target) {
				// Only prevent default if animation is actually gonna happen
				event.preventDefault();
				var scrollTop = target.getBoundingClientRect().top + window.pageYOffset - 150;
				var duration = 1000;
				var easing = function(t) {
				return t * (2 - t);
				};
				var start = window.pageYOffset;
				var time = 0;
				var animateScroll = function() {
				time += 16;
				var elapsed = time / duration;
				elapsed = elapsed > 1 ? 1 : elapsed;
				var eased = easing(elapsed);
				var newScrollTop = start + (scrollTop - start) * eased;
				window.scrollTo(0, newScrollTop);
				if (time < duration) {
					window.requestAnimationFrame(animateScroll);
				} else {
					// Callback after animation
					// Must change focus!
					var $target = $(target);
					$target.focus();
					if ($target.is(":focus")) { // Checking if the target was focused
					return false;
					} else {
					$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
					$target.focus(); // Set focus again
					};
				}
				};
				animateScroll();
			}
			}
		});
	}
}

//
// Modal Code
//
function modal_button_close() {
	// console.log('modal loaded');
	const closes = document.querySelectorAll('.close a');
	const html = document.querySelectorAll("html");
	closes.forEach(close => {
		close.addEventListener('click', (e) => {
			console.log('click');
			const modals = document.querySelectorAll('.modal-default');
			modals.forEach(modal => {
				modal.classList.remove("active");
			});
			html[0].classList.remove("lock-scroll");
			// tingle.destroy();
			e.preventDefault();
		});
	});
}
window.addEventListener('DOMContentLoaded', modal_button_close);

function modal_close() {
	// console.log('loaded');
	const closes = document.querySelectorAll('.close-button');
	const html = document.querySelectorAll("html");
	closes.forEach(close => {
		close.addEventListener('click', (e) => {
			console.log('click');
			const modals = document.querySelectorAll('.modal-default');
			modals.forEach(modal => {
				modal.classList.remove("active");
			});
			html[0].classList.remove("lock-scroll");
			// tingle.destroy();
			e.preventDefault();
		});
	});
}
window.addEventListener('DOMContentLoaded', modal_close);

function overlay_close() {
	const overlays = document.querySelectorAll('.modal-default .overlay');
	const html = document.querySelectorAll("html");
	overlays.forEach(overlay => {
		overlay.addEventListener('click', (e) => {
			const modals = document.querySelectorAll('.modal-default');
			modals.forEach(modal => {
				modal.classList.remove("active");
			});
			html[0].classList.remove("lock-scroll");
			// tingle.destroy();
			e.preventDefault();
		});
	});

}
window.addEventListener('DOMContentLoaded', overlay_close);

const sidebarOpen = document.querySelector('.sidebar-info');
const sticky_element = document.querySelector('.sticky-element');
const html = document.querySelectorAll("html");
if(sidebarOpen) {
	sidebarOpen.addEventListener('click', (e) => {
		e.preventDefault();
		sticky_element.classList.toggle("active");
		html[0].classList.toggle("lock-scroll");
	});
}

// History.goBack();
const back_buttons = document.querySelectorAll(".back");
back_buttons.forEach(back_button => {
	back_button.addEventListener('click', (e)=> {
		window.history.go(-1)
		e.preventDefault();
	});
});

//
// Modal contact
//
function modalContacts() {
	const modalbody = document.querySelector("body");
	const modal_form = document.querySelector(".form");
	const modal_form_l = document.querySelector(".form .form__l");
	const modal_form_r = document.querySelector(".form .form__r");
	const contact_buttons = document.querySelectorAll(".contact");
	contact_buttons.forEach(contact_button => {
		contact_button.addEventListener('click', (e)=> {
			const html = document.querySelectorAll("html");
			const modal = document.querySelector(".modal-default");
			console.log('contact');
			e.preventDefault();
			html[0].classList.add("lock-scroll");
			modal.classList.toggle("active");
			modalbody.classList.add("modal-slide");
			modal_form.style.transition = "0ms all ease-in-out";
			modal_form_l.style.transition = "0ms all ease-in-out";
			modal_form_r.style.transition = "0ms all ease-in-out";
		});
	});
}
window.addEventListener('DOMContentLoaded', modalContacts);

function modalQuotes() {
	const modal_form = document.querySelector(".form");
	const modal_form_l = document.querySelector(".form .form__l");
	const modal_form_r = document.querySelector(".form .form__r");
	const quote_buttons = document.querySelectorAll(".quote");
	quote_buttons.forEach(quote_button => {
		quote_button.addEventListener('click', (e)=> {
			const html = document.querySelectorAll("html");
			const modal = document.querySelector(".modal-default");
			console.log('contact');
			e.preventDefault();
			html[0].classList.add("lock-scroll");
			modal.classList.toggle("active");
			modal_form.style.transition = "0ms all ease-in-out";
			modal_form_l.style.transition = "0ms all ease-in-out";
			modal_form_r.style.transition = "0ms all ease-in-out";
		});
	});
}
window.addEventListener('DOMContentLoaded', modalQuotes);

function menuDropdown() {

	const primaryMenu = document.querySelector('#primary-menu');
	const menuItems = document.querySelectorAll('#primary-menu > .menu-item');

	if (isMobile()) {
		menuItems.forEach(el => {
			const dropdownMenu = el.querySelector('.dropdown-menu');
			const arrow = el.querySelector('.arrow');



			if(dropdownMenu) {
				// Get height of dropdowns before loaded then set value to 0 for proper display
				dropdownMenu.style.maxHeight = 'none';
				var boundingRect  = dropdownMenu.getBoundingClientRect();
				var height = boundingRect.height;
				dropdownMenu.style.maxHeight = '0';

				// Open dropdown menu on click + transforms
				arrow.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopPropagation(); // Prevents event propagation to prevent issues

					// Reset height, aria, and remove 'active' class from all <ul>
					menuItems.forEach(item => {
						const otherDropdownMenu = item.querySelector('ul');
						if(otherDropdownMenu && otherDropdownMenu !== dropdownMenu) {
							otherDropdownMenu.style.maxHeight = '0px';
							otherDropdownMenu.setAttribute('aria-sub-expanded', 'false');
							item.classList.remove('active');
						}
					});

					var value = dropdownMenu.getAttribute('aria-sub-expanded');
					var aria = value === 'true' ? 'false' : 'true';

					el.classList.add('active');
					dropdownMenu.setAttribute('aria-sub-expanded', aria);

					if (value === 'false') {
						dropdownMenu.style.maxHeight = height + 'px';

						// Focus on the first link when the dropdown is opened
						const firstLink = el.querySelector('ul a');
						if (firstLink) {
							firstLink.focus();
						}
					} else {
						dropdownMenu.style.maxHeight = '0px';
					}
				});
			}
		});
	}

	const siteHeader = document.querySelector('.site-header');

	// Remove 'active' class from all menu items
	function removeActiveClass() {
		menuItems.forEach(item => {
			item.classList.remove('active');
		});
	}

	// if (!isMobile()) {
		// Event listener for mouseenter and mouseleave on menu items
		menuItems.forEach(item => {
			const menuItemLink = item.querySelector('a');

			// Function to calculate the largest height and set it as a CSS variable
			function updateDropdownMaxHeight() {
				const dropdownMenus = document.querySelectorAll('.dropdown-menu');
				let maxHeight = 0;

				dropdownMenus.forEach((menu) => {
					const height = menu.offsetHeight; // Get the height of the current dropdown menu
					if (height > maxHeight) {
						maxHeight = height; // Update maxHeight if the current height is larger
					}
					// console.log(maxHeight);
				});

				const primaryMenu = document.querySelector('#primary-menu');
				if (primaryMenu) {
					primaryMenu.style.setProperty('--dropdown-max-height', `${maxHeight}px`);
				}
			}

			// Call the function on load
			document.addEventListener('DOMContentLoaded', () => {
				updateDropdownMaxHeight();
			});

			// Call the function on resize
			window.addEventListener('resize', () => {
				updateDropdownMaxHeight();
			});

			const menuItems = document.querySelectorAll('.menu-item-has-children');
			const primaryMenu = document.querySelector('#primary-menu');

			if (!isMobile()) {
				menuItemLink.addEventListener('mouseenter', () => {
					removeActiveClass();
					item.classList.add('active');
					if (item.classList.contains('menu-item-has-children')) {
						item.parentElement.classList.add('active');
					} else {
						item.classList.remove('active');
						item.parentElement.classList.remove('active');
					}
				});

				siteHeader.addEventListener('mouseleave', () => {
					item.classList.remove('active');
					item.parentElement.classList.remove('active');
				});
			}

			menuItemLink.addEventListener('click', event => {
				event.stopPropagation();
			});

			window.addEventListener('scroll', () => {
				item.parentElement.classList.remove('active');
				item.classList.remove('active');
			});

		});

		// Event listener for clicks outside of .menu-item-has-children
		document.addEventListener('click', event => {
			const menuItems = document.querySelectorAll('.menu-item-has-children');

			// Check if the click is inside any of the menu items
			const isClickInsideMenuItem = Array.from(menuItems).some(item => item.contains(event.target));

			if (!isClickInsideMenuItem) {
				// If click is outside of any menu item, remove active classes and reset styles
				primaryMenu.classList.remove('active');
				removeActiveClass();

				if (isMobile()) {
					menuItems.forEach(item => {
						const otherDropdownMenu = item.querySelector('ul');
						otherDropdownMenu.style.maxHeight = '0px';
						otherDropdownMenu.setAttribute('aria-sub-expanded', 'false');
						item.classList.remove('active');
					});
				}
			}
		});

		// Prevent click event from closing the menu when clicking inside it
		document.querySelectorAll('.menu-item-has-children').forEach(item => {
			item.addEventListener('click', event => {
				event.stopPropagation();
			});
		});
	// }
}

window.addEventListener('resize', menuDropdown); // Fixed window resize event
// document.addEventListener('DOMContentLoaded', menuDropdown);
menuDropdown();


//
// Ofc
//
window.addEventListener('load', function() {
	const container = document.querySelector('.menu-main-menu-container');
	// const menuBar = document.getElementById('menu-bar');

	const handleResize = function() {
	  const safeAreaBottom = window.innerHeight - document.documentElement.clientHeight;
	  container.style.paddingBottom = safeAreaBottom + 'px';
	};

	handleResize(); // Initial call to adjust padding

	window.addEventListener('load', handleResize);
  });
